<form class="gap-lg grid md:w-3/4 lg:w-1/2" [formGroup]="form()">
  <div hlmField>
    <label hlmFieldLabel for="nom-sequence" labelRequired>Nom de la séquence</label>
    <input id="nom-sequence" hlmInput type="text" formControlName="nom" />
  </div>

  <div hlmField>
    <label hlmFieldLabel for="code-sequence">Code de la séquence</label>
    <input id="code-sequence" hlmInput type="text" formControlName="code" />
  </div>

  <div hlmField>
    <label hlmFieldLabel for="duree-sequence" labelRequired>Durée</label>
    <input id="duree-sequence" hlmInput type="text" formControlName="duree" />
    <p hlmFieldDescription>En heures</p>
  </div>

  <div hlmField>
    <label hlmFieldLabel for="select-modalites" labelRequired>Modalité</label>
    @if (modalites().length > 0) {
      <hlm-select id="select-modalites" formControlName="modalites">
        <hlm-select-trigger class="capitalize">
          <hlm-select-value />
        </hlm-select-trigger>
        <hlm-select-content>
          @for (modalite of modalites(); track modalite.id) {
            <hlm-option class="capitalize" [value]="modalite.id">
              {{ modalite.nom }}
            </hlm-option>
          }
        </hlm-select-content>
      </hlm-select>
    } @else {
      <app-alerte
        message="Pour pouvoir sélectionner des modalités, il faut que les administrateurs en créent pour cette cartographie."
      />
    }
  </div>

  <div class="gap-xs flex flex-col" hlmField>
    <label hlmFieldLabel for="type-sequence" labelRequired>Type de séquence</label>
    <hlm-radio-group id="type-sequence" formControlName="type">
      <label class="flex items-center" for="positionnement-radio" hlmFieldLabel>
        <hlm-radio id="positionnement-radio" value="Positionnement"><hlm-radio-indicator indicator /></hlm-radio>
        Positionnement
      </label>
      <label class="flex items-center" for="formation-radio" hlmFieldLabel>
        <hlm-radio id="formation-radio" value="Formation"><hlm-radio-indicator indicator /></hlm-radio>
        Formation
      </label>
      <label class="flex items-center" for="evaluation-radio" hlmFieldLabel>
        <hlm-radio id="evaluation-radio" value="Évaluation"><hlm-radio-indicator indicator /></hlm-radio>
        Évaluation
      </label>
    </hlm-radio-group>
  </div>

  <div class="space-y-xxs mb-lg w-full" hlmField>
    <label hlmFieldLabel for="contexte" labelRequired>Contexte de la séquence</label>
    <textarea class="w-full" id="contexte" formControlName="contexte" hlmTextarea></textarea>
  </div>
</form>
